import { createReducer, on } from '@ngrx/store';
import { User } from '../../../user/models/user.model';

import {
  AuthApiActions,
  FirstConnectionActions
} from '@app/authentication/state/actions';

export interface State {
  user: User | null;
}

export const INITIAL_STATE: State = {
  user: null
};

export const reducer = createReducer(
  INITIAL_STATE,
  on(
    AuthApiActions.logoutSuccess,
    AuthApiActions.loadLoggedUserFailure,
    () => INITIAL_STATE
  ),
  on(AuthApiActions.loadLoggedUserSuccess, (state, { user }) => ({
    ...state,
    user
  })),
  on(AuthApiActions.consentSuccess, (state, { user }) => ({
    ...state,
    user
  })),
  on(FirstConnectionActions.firstUpdateUserInfosSuccess, state => ({
    ...state,
    user: {
      ...(state.user as User),
      preHomeData: true
    }
  }))
);

export const getUser = (state: State) => state.user;
